function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.868 8.778l-6.92 6.931c-.189.186-.444.291-.71.289h-4.24c-.552 0-1-.447-1-1v-4.24c-.002-.266.103-.521.29-.71l6.941-6.93 2.819-2.83c.188-.189.444-.296.711-.296.266 0 .521.107.709.296l4.239 4.291c.19.187.297.443.297.71 0 .266-.107.522-.297.709l-2.839 2.78zm-10.87 2.391v2.829h2.831l5.93-5.93-2.831-2.829-5.93 5.93zm8.761-8.761l-1.421 1.421 2.83 2.829 1.42-1.419-2.829-2.831zm4.239 7.59c.552 0 1 .448 1 1.001v6c0 1.656-1.343 2.999-3 2.999h-14c-1.657 0-3-1.343-3-2.999V2.998c0-1.657 1.343-3 3-3h6c.552 0 1 .448 1 1s-.448 1-1 1h-6c-.553 0-.999.448-.999 1v14.001c0 .552.446.999.999.999h14c.552 0 1-.447 1-.999v-6c0-.553.447-1.001 1-1.001z"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.ad646614.svg";
export { ForwardRef as ReactComponent };